var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mod-my-order"},[_c('amis-renderer',{attrs:{"schema":_vm.schema,"on-action":_vm.onAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }